import { Link, useLocation } from 'react-router-dom'
import { useSeo } from '../hooks/useSeo'

export default function NotFoundPage() {
  const location = useLocation()
  useSeo({
    title: 'Page not found | Em Whell Motorsport',
    description: "The page you're looking for doesn't exist.",
    path: location.pathname,
    noindex: true,
  })
  return <section className="not-found"><p className="eyebrow">404</p><h1>Wrong turn.</h1><p>This page isn’t on the racing line.</p><Link className="button button-primary" to="/">Return home</Link></section>
}
